// extracted by mini-css-extract-plugin
export var bullet = "_mj-q";
export var bulletText = "_mj-p";
export var bullets = "_mj-k";
export var callout = "_mj-g";
export var calloutBody = "_mj-i";
export var calloutLabel = "_mj-h";
export var checkIcon = "_mj-m";
export var checkList = "_mj-j";
export var checkSvg = "_mj-n";
export var checkText = "_mj-o";
export var fieldCard = "_mj-1";
export var fieldDescription = "_mj-5";
export var fieldHeader = "_mj-3";
export var fieldTitle = "_mj-4";
export var finalNote = "_mj-s";
export var flow = "_mj-x";
export var flowArrow = "_mj-v";
export var flowStep = "_mj-u";
export var helperText = "_mj-r";
export var inlineTitle = "_mj-t";
export var listItem = "_mj-l";
export var noteBody = "_mj-8";
export var noteBodyText = "_mj-9";
export var noteCard = "_mj-2";
export var noteIcon = "_mj-6";
export var noteTitle = "_mj-7";
export var productChoices = "_mj-w";
export var radioDot = "_mj-d";
export var radioDotSelected = "_mj-e";
export var radioDotSvg = "_mj-f";
export var selectableCard = "_mj-b";
export var selectableCardSelected = "_mj-c";
export var strongText = "_mj-a";
export var subHeading = "_mj-0";